import React from 'react';
import { Badge } from 'react-bootstrap';
import { Tag } from '../../types/tutorials.types';
import './TagFilters.scss';

interface TagFiltersProps {
  tags: Tag[];
  selectedTag: string | null;
  selectedSubTag: string | null;
  onTagSelect: (tagId: string | null) => void;
  onSubTagSelect: (subTagId: string | null) => void;
}

const TagFilters: React.FC<TagFiltersProps> = ({
  tags,
  selectedTag,
  selectedSubTag,
  onTagSelect,
  onSubTagSelect,
}) => {
  const hasActiveFilters = selectedTag !== null || selectedSubTag !== null;

  const handleClearFilters = () => {
    onTagSelect(null);
    onSubTagSelect(null);
  };

  return (
    <div className="tag-filters">
      {hasActiveFilters && (
        <div className="filters-header">
          <button className="clear-filters-btn" onClick={handleClearFilters}>
            Limpiar filtros
          </button>
        </div>
      )}

      <div className="main-tags">
        {tags.map((tag) => {
          const isSelected = selectedTag === tag.id;
          
          return (
            <div key={tag.id} className="tag-group">
              <Badge
                bg={isSelected ? 'warning' : 'light'}
                text={isSelected ? 'dark' : 'secondary'}
                className={`tag-badge ${isSelected ? 'active' : ''}`}
                onClick={() => onTagSelect(isSelected ? null : tag.id)}
              >
                {tag.icon && <span className="tag-icon">{tag.icon}</span>}
                <span className="tag-label">{tag.displayName}</span>
              </Badge>

              {isSelected && tag.subTags && tag.subTags.length > 0 && (
                <div className="sub-tags">
                  {tag.subTags.map((subTag) => {
                    const isSubTagSelected = selectedSubTag === subTag.id;
                    
                    return (
                      <Badge
                        key={subTag.id}
                        bg={isSubTagSelected ? 'warning' : 'light'}
                        text={isSubTagSelected ? 'dark' : 'secondary'}
                        className={`sub-tag-badge ${isSubTagSelected ? 'active' : ''}`}
                        onClick={() => onSubTagSelect(isSubTagSelected ? null : subTag.id)}
                      >
                        {subTag.displayName}
                      </Badge>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TagFilters;
